export const formatMillisecondsToMMSS = (milliseconds: number): string => {
  const totalSeconds = Math.floor(milliseconds / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
};

// Function to format MM:SS back to milliseconds (for domain calculations)
export const parseMMSSToMilliseconds = (timeString: string): number => {
  const [minutes, seconds] = timeString.split(":").map(Number);
  return (minutes * 60 + seconds) * 1000;
};
